import { useCallback } from 'react';
import { MSG_TYPE_EMBEDDED_COMMENT, MSG_TYPE_REMOVE_EMBEDDED_COMMENT } from 'collaboration-sidebar/constants/IFrameMessageTypes';
export default function useCommentIndicatorsSync({
  setModuleReply,
  removeModuleReply
}) {
  const handleMessage = useCallback(({
    payload
  }) => {
    if (payload.type === MSG_TYPE_EMBEDDED_COMMENT) {
      var _payload$comment;
      setModuleReply(payload.moduleId, (_payload$comment = payload.comment) !== null && _payload$comment !== void 0 ? _payload$comment : null);
    } else if (payload.type === MSG_TYPE_REMOVE_EMBEDDED_COMMENT) {
      const broadcastPayload = payload.payload;
      removeModuleReply(broadcastPayload.moduleId);
    }
  }, [setModuleReply, removeModuleReply]);
  return {
    handleMessage
  };
}